import { Tag } from "../../../graphql/operations";
import useSearch from "../../../hooks/useSearch";
import s from "./ProductTag.module.scss";

type ProductTagProps = Pick<Tag, "id" | "translation" | "name">;

export default function ProductTag({ id, translation, name }: ProductTagProps) {
  const { search } = useSearch();

  return (
    <button
      className={s.ProductTag}
      onClick={(e) => {
        e.preventDefault();
        search({ tags: new Set([id]) });
      }}
    >
      #{translation?.name ?? name}
    </button>
  );
}
